import * as yup from "yup";

export const AddressMaxLength = Object.freeze({
    Street: 30,
    AdditionalAddress: 35,
    MailBox: 10,
    HouseNumber: 5,
    BoxNumber: 4,
    ZipCode: 10,
    City: 40,
});

export const validateAddress = (): yup.AnyObjectSchema =>
    yup.object({
        mainAddress: yup.string().max(AddressMaxLength.Street).required(),
        additionalAddress: yup.string().max(AddressMaxLength.AdditionalAddress).nullable(),
        mailBox: yup.string().max(AddressMaxLength.MailBox).nullable(),
        number: yup.string().max(AddressMaxLength.HouseNumber).required(),
        postCode: yup.string().max(AddressMaxLength.ZipCode).required(),
        city: yup.string().max(AddressMaxLength.City).required(),
        country: yup.string().required(),
    });
